<template>
  <span v-if="sample">
    <span v-if="submitting">
      <i class="font-xl fal fa-spinner fa-spin" />
    </span>
    <span v-else-if="sampleCheck(sample)" @click="deleteSample(sample)">
      <i class="fal fa-check-square text-success fa-2x pointer" />
    </span>
    <span v-else @click="addSample(sample)">
      <i class="fal fa-square text-info fa-2x pointer" />
    </span>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const ProcessScheduleRepository = LabRepositoryFactory.get("processSchedule");
const ScheduleRepository = LabRepositoryFactory.get("schedule");

export default {
  name: "ScheduleSampleCheckbox",
  props: {
    sample: {
      type: Object,
      default: () => null,
    },
    sample_payload: {
      type: Object,
      default: () => null,
    },
    instrument_instance_schedules: {
      type: Array,
      default: () => null,
    },
    schedule_id: {
      type: String,
      default: null,
    },
    schedule_process_id: {
      type: String,
      default: null,
    },
    placement: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      submitting: false,
    };
  },
  computed: {
    ...mapGetters({
      schedule_form: "scheduleForm",
      schedule_sample_list: "scheduleSampleList",
    }),
    selected_samples() {
      return this.schedule_form.samples;
    },
  },
  methods: {
    ...mapActions(["UPDATE_SCHEDULE_FORM"]),
    sampleCheck(sample) {
      switch (this.placement) {
        case "cohort_table":
          return this.selected_samples.hasByID(sample);
        case "process_instrument_table":
          return !!this.schedule_sample_list.find(
            (item) =>
              item.sample_id === sample.id &&
              item.instrument_instance_id ===
                this.sample_payload.instrument_instance_id &&
              item.schedulable_task_id ===
                this.sample_payload.schedulable_task_id
          );
        default:
          return false;
      }
    },
    async addCohortSample(sample) {
      try {
        await ScheduleRepository.addSample(this.schedule_id, [sample.id]);
        this.$bvToast.toast("Selected sample was added to schedule.", {
          title: "Samples stored.",
          variant: "success",
        });
        const update = this.selected_samples;
        update.add(sample);
        this.UPDATE_SCHEDULE_FORM({ field: "samples", value: update });
        this.$emit("updateCohortSampleList", update.models);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Add Failed.",
          variant: "danger",
        });
      }
      this.submitting = false;
    },
    async deleteCohortSample(sample) {
      try {
        await ScheduleRepository.deleteSample(this.schedule_id, [sample.id]);
        this.$bvToast.toast("Schedule sample deleted.", {
          title: "Sample deleted successfully.",
          variant: "success",
        });
        const update = this.selected_samples;
        update.remove((store_sample) => store_sample.id === sample.id);
        this.UPDATE_SCHEDULE_FORM({ field: "samples", value: update });
        this.$emit("updateCohortSampleList", update.models);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Delete Failed.",
          variant: "danger",
        });
      }
      this.submitting = false;
    },
    async addInstrumentSample(sample) {
      try {
        const response = await ProcessScheduleRepository.addSample(
          this.schedule_process_id,
          [{ ...this.sample_payload, sample_id: sample.id }]
        );
        this.$emit("updateInstrumentSampleList", response.data);
        this.$bvToast.toast(
          "Selected sample was added to schedule instrument.",
          {
            title: "Sample stored",
            variant: "success",
          }
        );
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Add Failed.",
          variant: "danger",
        });
      }
      this.submitting = false;
    },
    async deleteInstrumentSample(sample) {
      const instrument_instance_schedule_id =
        this.instrument_instance_schedules.find(
          (item) =>
            item.sample_id === sample.id &&
            item.instrument_instance_id ===
              this.sample_payload.instrument_instance_id &&
            item.schedulable_task_id === this.sample_payload.schedulable_task_id
        ).id;

      try {
        const response = await ProcessScheduleRepository.deleteSample(
          this.schedule_process_id,
          [instrument_instance_schedule_id]
        );
        this.$emit("updateInstrumentSampleList", response.data);
        this.$bvToast.toast(
          "Selected sample was deleted from schedule instrument.",
          {
            title: "Sample deleted successfully.",
            variant: "success",
          }
        );
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Delete Failed.",
          variant: "danger",
        });
      }
      this.submitting = false;
    },
    addSample(sample) {
      this.submitting = true;
      switch (this.placement) {
        case "cohort_table":
          this.addCohortSample(sample);
          break;
        case "process_instrument_table":
          this.addInstrumentSample(sample);
          break;
        default:
      }
    },
    deleteSample(sample) {
      this.submitting = true;
      switch (this.placement) {
        case "cohort_table":
          this.deleteCohortSample(sample);
          break;
        case "process_instrument_table":
          this.deleteInstrumentSample(sample);
          break;
        default:
      }
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
